// delete after migrating back from helena — mesma chave que ENV['HELENA_KEY'] no backend
export const HELENA_EMBED_QUERY_KEY =
  'c6a874f995df115c5c074b967df70477bfae2f5b';
